<template>
    <div class="documentation-list-widget">
        <div class="controls">
            <button @click="showAddForm" class="btn btn-primary">Добавить документацию</button>
            <div class="search-box">
                <input
                    type="text"
                    v-model="searchTerm"
                    placeholder="Поиск по документации..."
                    @input="onSearch"
                >
            </div>
        </div>

        <div v-if="documentations.length === 0" class="no-results">
            Документация не найдена
        </div>

        <div v-else class="documentation-items">
            <div v-for="doc in documentations" :key="doc.id" class="documentation-item">
                <div class="item-header">
                    <h3>{{ doc.title }}</h3>
                    <div class="item-actions">
                        <button @click="editDocumentation(doc)" class="btn btn-sm btn-outline-secondary">Редактировать</button>
                        <button @click="deleteDocumentation(doc.id)" class="btn btn-sm btn-outline-danger">Удалить</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            documentations: [],
            searchTerm: ''
        };
    },
    mounted() {
        this.fetchDocumentations();
    },
    methods: {
        async fetchDocumentations(search = '') {
            try {
                const response = await axios.get('/api/documentations', {
                    params: { search }
                });
                this.documentations = response.data;
            } catch (error) {
                console.error('Error fetching documentations:', error);
            }
        },
        onSearch() {
            this.fetchDocumentations(this.searchTerm);
        },
        formatContent(content) {
            return content.replace(/\n/g, '<br>');
        },
        refresh() {
            this.fetchDocumentations(this.searchTerm);
        },
        showAddForm() {
            this.$emit('show-add-form');
        },
        editDocumentation(doc) {
            this.$emit('edit-documentation', doc);
        },
        async deleteDocumentation(id) {
            if (confirm('Вы уверены, что хотите удалить эту документацию?')) {
                try {
                    await axios.delete(`/api/documentations/${id}`);
                    this.refresh();
                } catch (error) {
                    console.error('Error deleting documentation:', error);
                }
            }
        }
    }
};
</script>

<style scoped>
.controls {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.search-box {
    width: 50%;
}

.search-box input {
    width: 100%;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 16px;
}

.documentation-items {
    display: grid;
    grid-template-columns: 1fr;
    gap: 20px;
}

.documentation-item {
    padding: 20px;
    border: 1px solid #ddd;
    border-radius: 8px;
    background-color: white;
}

.item-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
}

.item-actions {
    display: flex;
    gap: 10px;
}

.documentation-item h3 {
    margin-top: 0;
    color: #333;
}

.description {
    color: #666;
    margin-bottom: 15px;
}

.content {
    line-height: 1.6;
}

.no-results {
    padding: 20px;
    text-align: center;
    color: #666;
    font-style: italic;
}
</style>
